import axiosInstance from "../utils/axios";

export const complaintService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/complaint", { params });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get(`/complaint/${id}`);
    return response.data;
  },
  fetchCategories: async () => {
    const response = await axiosInstance.get("/complaint/categories");
    return response.data;
  },
};
